function MenuSeparator() {
  return <div className="separator" />;
}

export { MenuSeparator };
